import { OrganizationsApiKeysEffects } from './organizations/apikeys.effects';
import { OrganizationsBillingHistoryEffects } from './organizations/billing-history.effects';
import { OrganizationsCoreEffects } from './organizations/core.effects';
import { OrganizationsInvitationsEffects } from './organizations/invitations.effects';
import { OrganizationsMarkdownsEffects } from './organizations/markdowns.effects';
import { OrganizationsProjectsEffects } from './organizations/projects.effects';
import { OrganizationsSpecsEffects} from './organizations/specs.effects';
import { OrganizationsSubscriptionEffects } from './organizations/subscription.effects';
import { OrganizationsSupportEffects } from './organizations/support.effects';
import { OrganizationsUsersEffects } from './organizations/users.effects';

// Import other existing effects
import { AuthEffects } from './auth.effects';
import { PricingEffects } from './pricing.effects';
import { ThemeEffects } from './theme.effects';
import { UserEffects } from './user.effects';
import { TryItEffects } from './try-it.effects';

export const effects = [
  AuthEffects,
  PricingEffects,
  ThemeEffects,
  UserEffects,
  TryItEffects,

  OrganizationsApiKeysEffects,
  OrganizationsBillingHistoryEffects,
  OrganizationsCoreEffects,
  OrganizationsInvitationsEffects,
  OrganizationsMarkdownsEffects,
  OrganizationsProjectsEffects,
  OrganizationsSpecsEffects,
  OrganizationsSubscriptionEffects,
  OrganizationsSupportEffects,
  OrganizationsUsersEffects,
];
